<template>
  <div style="display: flex; flex-direction: column">
    <div class="query-bar">
      <el-select
        v-model="selectValue"
        placeholder="请选择"
        size="small"
        filterable
        clearable
        @change="selectChange"
      >
        <el-option
          v-for="item in selectOptions"
          :key="item.fid"
          :label="item.fName"
          :value="item.fid"
        />
      </el-select>
      <el-button type="primary" size="small" @click="addSystemPeople"
        >添加</el-button
      >
      <el-button type="primary" size="small" @click="delSystemPeople"
        >删除</el-button
      >
    </div>
    <div style="flex: auto; display: flex; flex-direction: column">
      <el-table
        v-loading="loading"
        v-el-table-height-fix
        :data="tableData"
        height="100%"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55" />
        <el-table-column prop="fNumber" label="人员编号" />
        <el-table-column prop="fName" label="人员名称" />
      </el-table>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      tableData: [],
      selectOptions: [],
      selectValue: "",
      loading: false,
      selectFid: "",
      selectArr: [],
    };
  },
  mounted() {
    this.refresh();
    this.getSystemPeople();
  },
  methods: {
    // 获取入库系统人员
    refresh() {
      this.loading = true;
      this.$httpPost("BasicInformation/Employee/StorekeeperEntry", this.query)
        .then((res) => {
          if (!res.isSuccess) {
            this.$message.error(res.message);
            return;
          }

          this.tableData = res.datalist;
          // this.pageRecordTotal = res.datalist.total;
        })
        .finally(() => (this.loading = false));
    },
    // 获取未设置入库系统人员
    getSystemPeople() {
      this.$httpPost(
        "BasicInformation/Employee/NoStorekeeperEntry",
        this.query
      ).then((res) => {
        if (!res.isSuccess) {
          this.$message.error(res.message);
          return;
        }

        this.selectOptions = res.datalist;
      });
    },
    // 选择框ID
    selectChange(e) {
      this.selectFid = e;
    },
    // 添加系统人员
    addSystemPeople() {
      if (this.selectFid === "") {
        return this.$message.error("请选择人员");
      }
      this.$httpPost("SystemApplication/Employee/AddStorekeeper", {
        fid: this.selectFid,
      }).then((res) => {
        if (!res.isSuccess) {
          this.$message.error(res.message);
          return;
        } else {
          this.$message.success(res.message);
          this.selectValue = "";
          this.selectFid = "";
          this.refresh();
          this.getSystemPeople();
        }
      });
    },
    // 批量删除系统人员
    delSystemPeople() {
      if (this.selectArr.length === 0) {
        return this.$message.error("请选择删除的人员");
      }
      this.$httpPost("BasicInformation/Employee/DeleteStorekeeper", {
        datalist: JSON.stringify(this.selectArr),
      }).then((res) => {
        if (!res.isSuccess) {
          this.$message.error(res.message);
          return;
        } else {
          this.$message.success(res.message);
          this.selectArr = [];
          this.refresh();
          this.getSystemPeople();
        }
      });
    },
    handleSelectionChange(val) {
      const arr = [];
      val.map((i) => {
        arr.push(i.fid);
      });
      this.selectArr = arr;
    },
  },
};
</script>
<style lang="">
</style>
